export default __webpack_public_path__ + "static/placement-dont-light-5c6e8b17ad142f1ca54cdf1d2e7e3757d9d809faf866c97b57a2ddec8d78fdf9.png";